import { Component } from '@angular/core';

@Component({
  selector: 'app-einhorn-impressum',
  imports: [],
  templateUrl: './einhorn-impressum.component.html',
  styleUrl: '../impressum.component.sass'
})
export class EinhornImpressumComponent {
  constructor() {
  }
}
